import { render, staticRenderFns } from "./Crown1.vue?vue&type=template&id=27f4099b&scoped=true"
import script from "./Crown1.vue?vue&type=script&lang=js"
export * from "./Crown1.vue?vue&type=script&lang=js"
import style0 from "./Crown1.vue?vue&type=style&index=0&id=27f4099b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4099b",
  null
  
)

export default component.exports